<div [mmTestId]="'AFTER_CHANGE_EMAIL.PAGE'">
  <app-email-sent
      [title]="'PAGES.ACCOUNT.AFTER_CHANGE_EMAIL.TITLE'"
      [returnToText]="'PAGES.ACCOUNT.AFTER_CHANGE_EMAIL.ELEMENTS.RETURN_TO_ACCOUNT'"
      [returnToLink]="templateOptions.accountInfoLink"
      [message]="'PAGES.ACCOUNT.AFTER_CHANGE_EMAIL.ELEMENTS.MESSAGE'"
      [tryAgainLink]="templateOptions.changeEmailLink"
  ></app-email-sent>
</div>
